import React, { ReactNode } from "react";

import { AppLayout } from "shared/Layout";
import { LegalContent } from "shared/LegalContent";
import { fetchSettings } from "shared/SettingsProvider/settings.helper";
import { CACHE_ONE_WEEK } from "utils/config.utils";
import { fetchPages } from "utils/fetch-page.utilts";
import { withApp } from "utils/with-app.utils";
import { fetchTranslations, useI18n } from "utils/with-i18n.utils";
import { fetchSEO, withSeo } from "utils/with-seo.utils";

type PrivacyPageProps = { privacy: string };

const PrivacyPage = ({ privacy }: PrivacyPageProps) => {
  const i18n = useI18n();

  return (
    <LegalContent
      content={privacy}
      title={i18n.t("privacy.title")}
      lastUpdate={i18n.t("privacy.lastUpdate")}
    />
  );
};

PrivacyPage.getLayout = (page: ReactNode, pageProps: any) => (
  <AppLayout {...pageProps}>{page}</AppLayout>
);

export async function getStaticProps() {
  const [privacy] = await fetchPages("privacy");
  const translations = await fetchTranslations("legal");

  const seo = await fetchSEO("confidentialite");

  return {
    props: {
      privacy: privacy.content,
      translations,
      seo,
      settings: await fetchSettings(),
    },
    revalidate: CACHE_ONE_WEEK,
  };
}

export default withApp(PrivacyPage, [withSeo]);
